import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { PlanningTicket } from 'store/planning';

interface Props {
    ticket: PlanningTicket;
    onEdit: (ticket: PlanningTicket) => void;
    onStatusChange: (ticket: PlanningTicket, status: string) => void;
}

const STATUS_LABELS: Record<string, string> = {
    todo: 'To Do',
    in_progress: 'In Progress',
    review: 'Review',
    done: 'Done',
    blocked: 'Blocked',
};

@observer
export class TicketCard extends Component<Props> {
    render() {
        const { ticket, onEdit, onStatusChange } = this.props;
        const status = ticket.status || 'todo';
        const assignee = ticket.assignee as any;
        const assigneeName = assignee ? (assignee.fullName || `${assignee.firstName || ''} ${assignee.lastName || ''}`.trim() || assignee.email) : 'Unassigned';

        return (
            <div
                className={`sp-ticket-card status-${status}`}
                data-test-ticket-card={ticket.id}
                data-test-ticket-edit={ticket.id}
                onClick={() => onEdit(ticket)}
            >
                <div className="sp-ticket-title">{ticket.title}</div>
                {ticket.description && (
                    <div className="sp-ticket-desc">{ticket.description}</div>
                )}
                <div className="sp-ticket-footer">
                    <div className="sp-ticket-meta">
                        <span className="sp-ticket-hours">{ticket.estimatedHours}h</span>
                        <span className="sp-ticket-assignee">{assigneeName}</span>
                    </div>
                    <select
                        className="sp-form-select sp-btn-sm"
                        value={status}
                        data-test-ticket-status-select={ticket.id}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => onStatusChange(ticket, e.target.value)}
                        style={{ width: 'auto', maxWidth: '120px', padding: '0.2rem 0.4rem' }}
                    >
                        {Object.keys(STATUS_LABELS).map(s => (
                            <option key={s} value={s}>{STATUS_LABELS[s]}</option>
                        ))}
                    </select>
                </div>
            </div>
        );
    }
}

export default TicketCard;
